import { CategoryWithSkills, SkillWithCareers, CategoryWithCareers } from 'labxchange-client';
import React from 'react';


  interface Props {
    careers: string[] | undefined;
  }

  export const CareerList: React.FC<Props> = ({ careers }) => {
    return (
      <div className='career-list'>
        {careers && careers.map((career) => (
          <span key={career} className='career-pill'>
            {career}
          </span>
        ))}
      </div>
    );
  };


interface SkillWithCareerProps {
  skills: SkillWithCareers[] | undefined;
}

export const SkillList: React.FC<SkillWithCareerProps> = ({ skills }) => {
  return (
    <div className='skill-list'>
      {skills?.map((skill) => (
        <div key={skill.id} className='skill'>
          <span className='skill-pill'>{skill.title}</span>
          {skill.careers?.length &&
            <CareerList careers={skill.careers}
          />}
        </div>
      ))}
    </div>
  );
};

interface CareerCategoryProps {
    categories: CategoryWithSkills[];
}

export const CareerCategoryList: React.FC<CareerCategoryProps> = ({ categories }) => {
    return (
      <div className='category-list'>
        {categories.map((category) => (
          <div key={category.id} className='category'>
            <h3>{category.categoryName}</h3>
            <SkillList skills={category.skills} />
          </div>
        ))}
      </div>
    );
};

interface SkillCategoryProps {
    categories: CategoryWithCareers[];
  }

  export const SkillCategoryList: React.FC<SkillCategoryProps> = ({ categories }) => {
    return (
      <div className='category-list'>
        {categories?.map((skillCategory) => (
          <div key={skillCategory.id} className='category'>
            <h3>{skillCategory.categoryName}</h3>
            {skillCategory.careers?.map((career) => (
              <div key={career.id} className='career'>
                <span className='career-pill'>{career.title}</span>
                <div className='career-skills'>
                  {career.skills?.map((skill, index) => (
                    <span key={index} className='skill-pill'>{skill}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };
